import { PrimaryValue } from './PrimaryValue';

export default PrimaryValue;
